const pricePlanCalculator = (section) => {
    if (!section) return;

    const form = section.querySelector('.pp-calculator__form');
    if(!form) return;
    const parcelInput = form.querySelector('.ppParcelInput');
    const palletInput = form.querySelector('.ppPalletInput');
    const submitInput = form.querySelector('.pp-calculator__btn');

    const resultsBlock = section.querySelector('.pp-calculator__results');
    const resultsBlockAttributes = resultsBlock.dataset;
    const plans = [...resultsBlock.querySelectorAll('.pp-calculator-plan')];
    let filteredPlan = '';

    const costPlus = +((resultsBlockAttributes.costPlus * 2) / 12);
    const costPro = +resultsBlockAttributes.costPro;
    const orderParcel = +resultsBlockAttributes.orderParcel;
    const orderPallet = +resultsBlockAttributes.orderPallet;
    const savingsParcelPlus = +(((resultsBlockAttributes.savingsParcel) / 100).toFixed(2));
    const savingsPalletPlus = +(((resultsBlockAttributes.savingsPallet) / 100).toFixed(2));

    const calculatePlan = () => {
        let parcelData = parcelInput && parcelInput.value;
        let palletData = palletInput && palletInput.value;

        let formulaPlusValue = (savingsParcelPlus * orderParcel * parcelData) + (savingsPalletPlus * orderPallet * palletData);
        let formulaProValue = ((orderParcel * parcelData) + (orderPallet * palletData));

        switch (true) {
            case (formulaPlusValue >= costPlus && formulaPlusValue < costPro && formulaProValue < costPro):
                return "sendify_plus";
            case (formulaPlusValue > costPlus && formulaProValue >= costPro):
                return "sendify_pro";
            default:
                return "sendify_free";
        }
    }

    const showPlan = () => {
        submitInput.value = submitInput.dataset.recalculate;
        submitInput.setAttribute('disabled', true);

        const current_plan = calculatePlan();

        filteredPlan = plans.find(item => item.dataset.plan === current_plan);
        filteredPlan.classList.add('active');
    }

    const hidePlan = () => {
        if(!submitInput.hasAttribute('disabled')) return;
        submitInput.removeAttribute('disabled');
        filteredPlan.classList.remove('active');
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        showPlan();
    });

    form.addEventListener('input', hidePlan);
}

export default pricePlanCalculator;



// WEBPACK FOOTER //
// ./scripts/modules/ppCalc.js